import React from 'react'
import { Paper, Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import VerifiedIcon from '@mui/icons-material/Verified'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import { Colors } from '../../styles/theme' // ADDED: Import Colors

const BannerContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    padding: '20px 15px',
    background: Colors.boltGold2, // CHANGED: was '#B19470'
    gap: '30px',
    borderRadius: '8px',
    overflow: 'hidden',

    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        padding: '15px 10px',
        gap: '15px',
    },
}))

const BannerContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: '1 1 auto',
    maxWidth: 420,
    minWidth: 0,
    padding: '20px',
    boxSizing: 'border-box',

    [theme.breakpoints.down('md')]: {
        padding: '10px',
        order: 2,
        textAlign: 'center',
        maxWidth: '100%',
    },
}))

const BannerImage = styled('img')(({ theme }) => ({
    width: '100%',
    maxWidth: '440px',
    height: 'auto',
    aspectRatio: '440 / 420', // Maintains proportions
    objectFit: 'cover',
    borderRadius: '8px',
    border: `2px solid ${Colors.black}`,
    flexShrink: 0,

    [theme.breakpoints.down('md')]: {
        maxWidth: '400px',
    },
    [theme.breakpoints.down('sm')]: {
        maxWidth: '300px',
    },
}))

const BannerTitle = styled(Typography)(({ theme }) => ({
    lineHeight: 1.25,
    fontSize: '56px',
    marginBottom: '0.4em',
    textShadow: `2px 2px 2px ${Colors.greenDark}`, // CHANGED: was '#006e64'
    color: Colors.cream, // CHANGED: was '#fef4e9'
    fontWeight: 700,

    [theme.breakpoints.down('md')]: {
        fontSize: '42px',
    },

    [theme.breakpoints.down('sm')]: {
        fontSize: '32px',
    },
}))

const BannerDescription = styled(Typography)(({ theme }) => ({
    fontSize: '1.1rem',
    lineHeight: 1.4,
    marginBottom: '0.8em',
    color: Colors.cream, // CHANGED: was '#fef4e9'
    textShadow: `1px 1px 1px ${Colors.black}`, // CHANGED: was '#000'

    [theme.breakpoints.down('md')]: {
        fontSize: '1rem',
    },
}))

const TrustBadgesContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
    },
}))

const TrustBadge = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(0.5),

    '& .icon': {
        fontSize: '1.8rem',
        color: Colors.cream, // CHANGED: was '#fef4e9'
    },

    '& .label': {
        fontSize: '0.7rem',
        color: Colors.cream, // CHANGED: was '#fef4e9'
        textAlign: 'center',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
}))

export default function Banner() {
    return (
        <Paper
            elevation={14}
            sx={{ marginBottom: 0, borderRadius: '8px', overflow: 'hidden' }}
        >
            <BannerContainer>
                <BannerImage
                    src="/shop/images/banner/banner.png"
                    alt="ElectroBraid Horse Fence"
                />
                <BannerContent>
                    <BannerDescription
                        variant="h6"
                        sx={{ marginBottom: '1.8rem' }}
                    >
                        An ingeniously simple permanent electric fence.
                    </BannerDescription>

                    <BannerTitle variant="h2">
                        Safe, Simple and Secure
                    </BannerTitle>

                    {/* <BannerDescription variant="h6">
                        A 25 Year old company with a 25 year Warranty.
                    </BannerDescription> */}

                    <BannerDescription
                        variant="h6"
                        sx={{ marginBottom: '1.8rem' }}
                    >
                        Safe. Easy to Install. Almost No Maintenance.
                    </BannerDescription>

                    {/* Trust badges with SVG icons */}
                    <TrustBadgesContainer>
                        <TrustBadge>
                            <VerifiedIcon className="icon" />
                            <Typography className="label">
                                25-Year Warranty
                            </Typography>
                        </TrustBadge>

                        <TrustBadge>
                            <SupportAgentIcon className="icon" />
                            <Typography className="label">
                                Since 1998
                            </Typography>
                        </TrustBadge>

                        <TrustBadge>
                            <LocalShippingIcon className="icon" />
                            <Typography className="label">
                                Made in USA
                            </Typography>
                        </TrustBadge>
                    </TrustBadgesContainer>
                </BannerContent>
            </BannerContainer>
        </Paper>
    )
}
